import React from 'react';
import { Button } from '../components/ui/Button';
import { UnifiedHeader } from '../components/layout';

export interface NotFoundPageProps {
  onGoHome?: () => void;
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({ onGoHome }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <UnifiedHeader />
      <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] mt-16">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-300">404</h1>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Page Not Found
        </h2>
        <p className="text-gray-600 mb-8 max-w-md">
          Sorry, we couldn't find the page you're looking for. 
          It might have been moved or doesn't exist.
        </p>
        <Button
          variant="primary"
          onClick={onGoHome}
        >
          Go Back Home
        </Button>
      </div>
      </div>
    </div>
  );
};

export { NotFoundPage };